/** Zaynic cinematic motion tokens — tween only (no springs). */

export const CINEMATIC_EASE = [0.22, 1, 0.36, 1];

export const DURATIONS = {
  heroReveal: 1.4,
  textReveal: 0.9,
  scrollReveal: 0.7,
  micro: 0.22,
};

export const DELAYS = {
  heroText: 0.52,
  staggerChild: 0.08,
};

/** Magnetic follow — short tween, same ease curve. */
export const MAGNETIC_TWEEN = {
  type: 'tween',
  duration: DURATIONS.micro,
  ease: CINEMATIC_EASE,
};
